export default __webpack_public_path__ + "static/media/Two Buttons.ebaa5491.svg";